// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3auPC","placeholdersHeader":"styles_placeholdersHeader__316A2","editorStyle":"styles_editorStyle__2j_H7","placeholdersBox":"styles_placeholdersBox__1Li2t"};